// @ts-nocheck: converted from JS

import Loading from './Loading';

export default Loading;
export { default as LoadingMain } from './LoadingMain';
